import {
    changeActiveWheels, changeCutType, changeIsRunflat,
    changeRadius,
    changeWheelDiskType, setCutType,
    setIsActive,
    setRadius,
    setWheelDiskType
} from "./constants";
import axios from "../../../plugins/axios-common";


export default {
    namespaced: true,
    state: {
        isFirstTab: {},
        tireName:[0,12,13,14,15,16,17,18,19,20,21,22,23,24],
        loading: true,
        availableTire: {},
        carTypeSelected: {},
        // carType:[
        //     {id:1, name:'лекговой', icon:'car-side'},
        //     // {id:2, name:'джип', icon:'car-estate'},
        //     {id:3 , name:'газель', icon:'truck'},
        // ],
        ChangePrice: [],
        url: '/calc/',
        QRcodeUrl: '/QR.png',
        wheels:{
            forwardLeft: {},
            forwardRight:{},
            backLeft: {},
            backRight: {},
            spareLeft: {},
            spareRight: {},
        }
    },
    mutations: {
        setCarType (state, payload) {
            const {value, side, type} = payload;
            if(state.isFirstTab[type]){
                for (let x in state.wheels){
                    state.wheels[x][type].data.carType = value
                }
            } else{
                state.wheels[side][type].data.carType = value
            }
        },
        addIsFirstTab  (state, payload) {
            const {value, type } = payload;
            state.isFirstTab[type] = value
            state.isFirstTab = Object.assign({},state.isFirstTab, state.isFirstTab)

        },
        addData (state, payload) {
            const {value, side } = payload;
            state.wheels[side] = Object.assign({},state.wheels[side], value)
        },
        setIsFirstTab (state, payload) {
            const {value, type } = payload;
            state.isFirstTab[type] = value
        },
        addAvailableTire (state, value) {
            state.availableTire = Object.assign({},state.availableTire, value)
        },
        [setRadius](state, payload) {
            const {value, side, type} = payload;
            if(state.isFirstTab[type]){
                for (let x in state.wheels){
                    state.wheels[x][type].data.radius = value
                }
            } else{
                state.wheels[side][type].data.radius = value
            }
        },
        setChangePrice(state, value) {
            state.ChangePrice = value
        },
        setLoading(state, value) {
            state.loading = value
        },
        carTypeSelect (state, payload) {
            const {value, type} = payload;
            state.carTypeSelected[type] = value
        },
        [setIsActive](state, payload) {
            const {value, side, type} = payload;
            state.wheels[side][type].isActive = value
        },
        [setWheelDiskType](state, payload) {
            const {value, side, type} = payload;
            if(state.isFirstTab[type]){
                for (let x in state.wheels){
                    state.wheels[x][type].data.solidDisk = value
                }
            } else{
                state.wheels[side][type].data.solidDisk = value
            }
        },
        setIsRunflat (state, payload) {
            const {value, side, type} = payload;
            if(state.isFirstTab[type]){
                for (let x in state.wheels){
                    state.wheels[x][type].data.isRunflat = value
                }
            } else{
                state.wheels[side][type].data.isRunflat = value
            }
        },
        setIsFrameVehicle (state, payload) {
            const {value, side, type} = payload;
            if(state.isFirstTab[type]){
                for (let x in state.wheels){
                    state.wheels[x][type].data.isFrameVehicle = value
                }
            } else{
                state.wheels[side][type].data.isFrameVehicle = value
            }
        },
    },
    actions: {
        async init({ commit, state, rootState, rootGetters }, value) {
            let count = 1
            let getRad = rootState.clientCard.diskSize.replace('R','')
            getRad = state.tireName.findIndex(r => r === getRad)
            const carType = rootState.clientCard.carTypeArr.find(ct => ct.service.slug == rootGetters["login/chosenDirectionSlug"])
            for (let name in state.wheels){
                let data = {}
                data[value] = {
                    isActive: count<=1,
                    data:{
                        radius: parseInt(rootState.clientCard.diskSize.replace('R','')),
                        radiusRate: 0,
                        solidDisk: rootState.clientCard.diskType!=="shtamp",
                        isRunflat: rootState.clientCard.runflat,
                        isFrameVehicle: rootState.clientCard.frameVehicle,
                        carType: carType.id || parseInt(rootState.clientCard.carType),
                    }
                }
                commit('addData', { side: name, value: data })
                count++
            }
            commit('addIsFirstTab', { value: false, type: value })

        },
        changePrice ({ state, commit, rootState }, value) {
            return new Promise((resolve, reject) => {
                const runflat = value ? value.runflat : rootState.clientCard.runflat
                const frame = value ? value.frameVehicle : rootState.clientCard.frameVehicle
                axios({
                    method: 'get',
                    url: `calc/simple.json?runflat=${runflat}&framevehicle=${frame}`,
                }).then((response) => {
                        let tempChangeprice = {}
                        for (let x in response.data) {
                            let availableTire = {}
                            response.data[x].forEach((s) => {
                                if ( !availableTire[s.car_type_id] ) { availableTire[s.car_type_id] = {} }
                                if ( !availableTire[s.car_type_id][state.tireName[s.wheel_diameter_id]] ) {
                                    availableTire[s.car_type_id][state.tireName[s.wheel_diameter_id]] = s.wheel_diameter_id
                                }
                            })
                            tempChangeprice[x] = { services:response.data[x] , availableTire: availableTire }
                        }
                        commit('setChangePrice', tempChangeprice )
                        commit('setLoading', false )
                        resolve(response.data)

                    }).catch((e) => {
                    reject(e)
                })
            })
        },
        setRadius({state, commit}, payload) {
            // console.log('sss0',payload)
            const { value, side } = payload;
            commit(setRadius, payload)
            if(value > 12){
                for (let x in state.extraDiameters) {
                    // console.log(x)
                    if (state.extraDiameters[x].radius == value) {
                        commit('setRadiusRate', { side, value: state.extraDiameters[x].price})
                    }
                }
            }
        },
        [changeIsRunflat]({commit}, payload) {
            commit('setIsRunflat', payload)
        },
        [changeActiveWheels]({commit}, payload) {
            const { type, sides } = payload;
            for (const side in sides) {
                commit(setIsActive, {side, value: sides[side], type:type})
            }
        },
        [changeRadius]({state, commit}, payload) {
            const {side, value} = payload;
            const options = state[side].data.radius.map(option => {
                if (option.value === value) {
                    return {...option, selected: true}
                } else {
                    return {...option, selected: false}
                }
            });
            commit(setRadius, {side, value: options})
        },
        [changeWheelDiskType]({commit}, payload) {
            commit(setWheelDiskType, payload)
        },

        [changeCutType]({commit}, payload) {
            commit(setCutType, payload)
        },
    },
    getters: {
        sides: state => [
            {...state.forwardLeft, sideName: 'forwardLeft'},
            {...state.forwardRight, sideName: 'forwardRight'},
            {...state.backLeft, sideName: 'backLeft'},
            {...state.backRight, sideName: 'backRight'},
            {...state.spareLeft, sideName: 'spareLeft'},
            {...state.spareRight, sideName: 'spareRight'},
        ],
    },
}
